<template>
  <validation-provider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :vid="$attrs.vid"
  >
    <v-select
      v-bind="$attrs"
      :loading="loading"
      :id="id"
      :label="name"
      :placeholder="placeholder || name"
      :error-messages="errors"
      :disabled="disabled"
      outlined
      :dense="dense"
      :value="value"
      @input="handleInput"
      @change="handleChange"
      :append-icon="icon"
      @click:append="handleAppendClick"
    ></v-select>
  </validation-provider>
</template>

<script>
import { required } from "vee-validate/dist/rules";
import { extend, ValidationProvider } from "vee-validate";

extend("required", {
  ...required,
  message: "Favor informar {_field_}."
});

export default {
  components: {
    ValidationProvider
  },
  props: {
    name: {
      type: String
    },
    rules: {
      type: [String, Object]
    },
    id: {
      type: String
    },
    value: [String, Number, Boolean],
    counter: {
      type: Number
    },
    icon: {
      type: String
    },
    dense: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    inputType: {
      type: String,
      default: "input"
    },
    placeholder: {
      type: String
    }
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    },
    handleAppendClick(e) {
      this.$emit("handlerAppendClick", e);
    },
    handleChange(e) {
      this.$emit("handleChange", e);
    }
  }
};
</script>

<style></style>
